import React from 'react'
import {
WalletCardContent,
Page3CardCaption,
WalletContainer,
WalletType,
WalletIcon
} from './walletCardStyle'

import Crypto from "../../../assets/Crypto";
import { useTranslation } from "react-i18next";



const WalletCard = ({display}) => {
    const { t } = useTranslation();

  return (
    <>
          <WalletCardContent display = {display} >
            <Page3CardCaption>{t("page3.page3CardCaption")}</Page3CardCaption>
            <WalletContainer>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet1")}
              </WalletType>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet2")}
              </WalletType>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet3")}
              </WalletType>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet4")}
              </WalletType>
            </WalletContainer>
          </WalletCardContent>
    </>
  )
}

export default WalletCard